import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import useStyles from './styles';
export default function CurrentCycle(_ref) {
  let _ref$daysTillStatemen = _ref.daysTillStatementDate,
    daysTillStatementDate = _ref$daysTillStatemen === void 0 ? 0 : _ref$daysTillStatemen,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'Month Year' : _ref$name,
    _ref$statementDate = _ref.statementDate,
    statementDate = _ref$statementDate === void 0 ? '--/--/----' : _ref$statementDate;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const isPaymentClose = () => {
    if (daysTillStatementDate < 6) {
      return 'error';
    } else if (daysTillStatementDate < 16) {
      return 'warning';
    } else {
      return 'success';
    }
  };
  const classes = useStyles({
    isPaymentClose: isPaymentClose()
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.currentStatementTitle
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, t('allocations.current_statement_period')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, name)), /*#__PURE__*/React.createElement("div", {
    className: classes.currentStatementDate
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, t('allocations.statements_will_be_send')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    align: "right"
  }, statementDate)), /*#__PURE__*/React.createElement("div", {
    className: classes.currentStatementDays
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, daysTillStatementDate > 0 ? "".concat(daysTillStatementDate, " ").concat(t('allocations.days_left')) : t('general.today')))));
}
CurrentCycle.propTypes = {
  daysTillStatementDate: PropTypes.number,
  name: PropTypes.string,
  statementDate: PropTypes.string
};